export default {
  install: function (Vue, options) {
    Vue.prototype.$config = options
  }
}



// WEBPACK FOOTER //
// ./src/common/plugins/config.js